import ServicoEntregaModel from "@/models/servicoEntregaModel";
import nfetch from "@/utils/events/nfetch";

import { IService } from "./base/iService";

export default class ServicoEntregaService extends IService<ServicoEntregaModel> {
    constructor() {
        super("ServicoEntrega");
    }

    public listCorreios(): Promise<Response> {
        return nfetch(`/${this.controllerName}/ListCorreios?`, {
            credentials: "same-origin",
        });
    }
}
